import http from '../lib/http';

export const OPEN_TABLES = 'OPEN_TABLES';
export const CLOSE_TABLES = 'CLOSE_TABLES';

export const OPEN_DIVIDE_TABLE = 'OPEN_DIVIDE_TABLE';
export const CLOSE_DIVIDE_TABLE = 'CLOSE_DIVIDE_TABLE';
export const DIVIDE_PAY_ALL = 'DIVIDE_PAY_ALL';
export const DIVIDE_REMOVE_ALL = 'DIVIDE_REMOVE_ALL';
export const MARK_DIVIDE_ITEM = 'MARK_DIVIDE_ITEM';
export const DIVIDE_MOVE_FROM_TO = 'DIVIDE_MOVE_FROM_TO';
export const DIVIDE_MOVE_TO_FROM = 'DIVIDE_MOVE_TO_FROM';
export const ADD_TO_TABLE = 'ADD_TO_TABLE';

export const DIVIDE_COUNT_INCREASE = 'DIVIDE_COUNT_INCREASE';
export const DIVIDE_COUNT_INCREASE_HALF = 'DIVIDE_COUNT_INCREASE_HALF';
export const DIVIDE_COUNT_DECREASE = 'DIVIDE_COUNT_DECREASE';
export const DIVIDE_SET_PCS_KEYBOARD = 'DIVIDE_SET_PCS_KEYBOARD';

export const OPEN_NEW_TABLE = 'OPEN_NEW_TABLE';
export const CLOSE_NEW_TABLE = 'CLOSE_NEW_TABLE';

export const OPEN_TABLE = 'OPEN_TABLE';
export const DELETE_TABLE = 'DELETE_TABLE';
export const SHOW_TABLE = 'SHOW_TABLE';
export const CLOSE_SHOW_TABLE = 'CLOSE_SHOW_TABLE';
export const SET_DEFAULT_TABLE_VISIBLE = 'SET_DEFAULT_TABLE_VISIBLE';
export const GO_HOMEPAGE = 'GO_HOMEPAGE';

export const TABLE_SAVE = 'TABLE_SAVE';
export const TABLE_MERGE = 'TABLE_MERGE';

export const TABLE_NEXT_PAGE = 'TABLE_NEXT_PAGE';
export const TABLE_PREV_PAGE = 'TABLE_PREV_PAGE';
export const REMOVE_TABLE_LIST = 'REMOVE_TABLE_LIST';
export const ADD_TABLE_LIST = 'ADD_TABLE_LIST';

export const FETCH_LAYOUTS_ERROR = 'FETCH_LAYOUTS_ERROR';
export const FETCH_LAYOUTS_START = 'FETCH_LAYOUTS_START';
export const FETCH_LAYOUTS_SUCCESS = 'FETCH_LAYOUTS_SUCCESS';

export const SELECT_LAYOUT = 'SELECT_LAYOUT';
export const PREPARE_TABLE_TO_PRINT = 'PREPARE_TABLE_TO_PRINT';
export const CLOSE_TABLE_TO_PRINT = 'CLOSE_TABLE_TO_PRINT';

export function selectLayout(id) {
    return {
        type: SELECT_LAYOUT,
        payload: id
    }
}

export function addTableList() {
    return {
        type: ADD_TABLE_LIST
    }
}

export function removeTableList() {
    return {
        type: REMOVE_TABLE_LIST
    }
}

export function goTableNextPage() {
    return {
        type: TABLE_NEXT_PAGE
    }
}

export function goTablePrevPage() {
    return {
        type: TABLE_PREV_PAGE
    }
}

export function goHomepage() {
    return {
        type: GO_HOMEPAGE
    }
}

export function setDefaultTableVisible(visible) {
    return {
        type: SET_DEFAULT_TABLE_VISIBLE,
        payload: visible
    }
}

export function setDividePcsKeyboard(key) {
    return {
        type: DIVIDE_SET_PCS_KEYBOARD,
        payload: {key}
    }
}

export function divideCountIncrease() {
    return {
        type: DIVIDE_COUNT_INCREASE
    }
}

export function divideCountIncreaseHalf() {
    return {
        type: DIVIDE_COUNT_INCREASE_HALF
    }
}

export function divideCountDecrease() {
    return {
        type: DIVIDE_COUNT_DECREASE
    }
}

export function closeTableToPrint() {
    return {
        type: CLOSE_TABLE_TO_PRINT
    }
}

export function prepareTableToPrint(isInformative = false) {
    return {
        type: PREPARE_TABLE_TO_PRINT,
        payload: isInformative
    }
}

export function markDivideItem(uuid) {
    return {
        type: MARK_DIVIDE_ITEM,
        payload: uuid
    }
}

export function tableMerge(uuid, msg) {
    return {
        type: TABLE_MERGE,
        payload: {uuid, msg}
    }
}

export function tableSave(uuid, msg) {
    return {
        type: TABLE_SAVE,
        payload: {uuid, msg}
    }
}

export function closeShowTable() {
    return {
        type: CLOSE_SHOW_TABLE
    }
}

export function openTable(uuid, name, toHomepage, msg) {
    return {
        type: OPEN_TABLE,
        payload: {uuid, name, toHomepage, msg}
    }
}

export function deleteTable(uuid) {
    return {
        type: DELETE_TABLE,
        payload: uuid
    }
}

export function showTable(uuid) {
    return {
        type: SHOW_TABLE,
        payload: uuid
    }
}

export function dividePayAll() {
    return {
        type: DIVIDE_PAY_ALL
    }
}

export function divideRemoveAll() {
    return {
        type: DIVIDE_REMOVE_ALL
    }
}

export function divideMoveFromTo() {
    return {
        type: DIVIDE_MOVE_FROM_TO
    }
}

export function divideMoveToFrom() {
    return {
        type: DIVIDE_MOVE_TO_FROM
    }
}

export function openDivideTables() {
    return {
        type: OPEN_DIVIDE_TABLE
    }
}

export function closeDivideTable() {
    return {
        type: CLOSE_DIVIDE_TABLE
    }
}

export function openTables() {
    return {
        type: OPEN_TABLES
    }
}

export function closeTables() {
    return {
        type: CLOSE_TABLES
    }
}

export function addToTable(uuid) {
    return {
        type: ADD_TO_TABLE,
        payload: uuid
    }
}

export function openNewTable(uuid) {
    return {
        type: OPEN_NEW_TABLE,
        payload: uuid
    }
}

export function closeNewTable() {
    return {
        type: CLOSE_NEW_TABLE
    }
}

export function fetchLayouts(barId) {
    return {
        type: 'FETCH_LAYOUTS',
        payload: {
            promise: getLayouts(barId)
        }
    };
}

async function getLayouts(barId) {
    const res = await http.get(`/app/layouts/list/${barId}`);
    if (res.status < 300) return res.json();
    throw res.json();
}



// WEBPACK FOOTER //
// ./src/common/tables/actions.js